import { Analytics } from '@simple-life-app/simple-growth-frontend-tools'
import { useMainStore } from '@/store/main'
import { useLocationStore } from '@/store/location'
import { useSurveyStore } from '@/store/survey'

let analyticInstance = null
export const getAnalytic = () => analyticInstance

export default {
	install: (app, { options, router }) => {
		const analytic = new Analytics(options)

		const mainStore = useMainStore()

		// Проверяем превью мод один раз при инициализации
		const isPreviewMode = mainStore.isPreviewMode

		// Регистрируем router hook только если не превью мод
		if (!isPreviewMode) {
			router.beforeEach((to) => {
				const hasAnalyticData = Boolean(to.meta.pageAnalyticUxEvent)

				if (hasAnalyticData && !Boolean(to.query.popup)) {
					const { name, data } = to.meta.pageAnalyticUxEvent

					analytic.logEvent(name, data)
				}
			})
		}

		// Создаем методы аналитики с учетом превью мода
		const createAnalyticMethod = (originalMethod) => {
			return isPreviewMode ? () => Promise.resolve() : originalMethod
		}

		const analyticApi = {
			logEvent: createAnalyticMethod((eventName, eventProperties) => {
				const locationStore = useLocationStore()
				const { funnel } = locationStore.getAppAreaConfig
				const initialFunnelType = locationStore.getInitialFunnelType
				const initialFunnelId = locationStore.getInitialFunnelId

				// FwF: на экранах самого пре-фаннела (роут `fwf`) текущая воронка — это
				// fwf-воронка, хотя appAreaConfig уже родительский (его сажает bootstrapFwf).
				// Поэтому funnel_id на `/fwf/*` берём из initialFunnelId (fwf-алиас, ставится
				// только для активной записи реестра), после хендоффа он сам возвращается к
				// родительскому. initial_funnel_id при этом несёт fwf-алиас всю сессию —
				// зеркало Jet-контекста `onboarding_initial_funnel_id` в App.vue.
				//
				// ВАЖНО: вне fwf-сессий форма ивента не меняется вообще (никаких новых
				// ключей) — E2E paywall-аналитики матчит свойства строго, и постоянный
				// initial_funnel_id уронил verifyPaywallEvents на всех обычных воронках.
				const onFwfRoute = router.currentRoute.value?.name === 'fwf'

				return analytic.logEvent(eventName, {
					url: window.location.href,
					...(initialFunnelId ? { initial_funnel_id: initialFunnelId } : {}),
					initial_funnel_type: initialFunnelType,
					funnel_type: funnel.slug,
					funnel_id: (onFwfRoute && initialFunnelId) || funnel.id,
					...eventProperties,
				})
			}),
			setUserProperties: createAnalyticMethod((...args) => {
				const surveyStore = useSurveyStore()
				// Note: этот метод можно будет перенести в Jet после отказа от Amplitude
				surveyStore.handleUserAnalyticData(...args)
				return analytic.setUserProperties(...args)
			}),
			initDestinationPlugins: (...args) => analytic.initDestinationPlugins(...args),
			setUserId: (...args) => analytic.setUserId(...args),
		}

		analyticInstance = analyticApi
		app.config.globalProperties.$analytic = analyticApi
	},
}
